import React, {useEffect, useRef, useState} from 'react';
import { useTranslation } from 'react-i18next';
import './StudioAuthoringProgramCreationViewContent.css';
import {Link} from 'react-router-dom';
import {getTenant, IBLSpinLoader} from "@iblai/ibl-web-react-common";
import Async from "react-select/async";
import useProgramCreation from "../../../hooks/utils/useProgramCreation";
import dayjs from "dayjs";

const StudioAuthoringProgramCreationViewContent = () => {
  const { t } = useTranslation();
  const {submitting,
    fields,
    setFields,
    imageCardUploadResponse,
    setImageCardUploadResponse,
    handleFormSubmit,
    notificationRef,
    notification,
    coursePromiseOptions,
    handleCourseChange} = useProgramCreation()

  const handleInputChange = (e) => {
    setFields(old=>({
      ...old,
      [e?.target?.name]:e?.target?.value
    }))
  }

  //IMAGE CARD UPLOAD
  const [imageCardUploadLoading, setImageCardUploadLoading] = useState(false)
  const imageCardUploadInputElement = useRef(null)
  const MAX_FILE_SIZE = 1024 * 1024 * 2
  const handleImageCardUploadChange = async (e) => {
    if (!e) {
      return;
    }
    const file = e?.target?.files[0];
    if (file.size >= MAX_FILE_SIZE) {
      alert('Image card size must not exceed 2Mb');
      return;
    }
    let fileName = file.name;
    // Check if the file name exceeds 10 characters (excluding the extension)
    if (fileName.length > 20) {
      const fileExtension = fileName.substring(fileName.lastIndexOf('.'));
      const baseName = fileName.substring(0, fileName.lastIndexOf('.'));
      // Truncate the base name and append the extension
      fileName = `${baseName.substring(0, 20 - fileExtension.length)}...${fileExtension}`;
    }
    const blobImg = URL.createObjectURL(file);
    setImageCardUploadResponse((old)=>({
      ...old,
      asset:{
        ...old.asset,
        display_name:fileName,
        external_url:blobImg
      }
    }))
    setFields((old)=>({
      ...old,
      file: file
    }))
    imageCardUploadInputElement.current.value = '';
  };

  const handleImageCardUploadClick = () => {
    imageCardUploadInputElement.current.click();
  };
  return (
      <>
        <div className="div-block-183">
          <div className="div-block-205">
            <div className="div-block-206"/>
            <div className="text-block-113">Programs | Add new</div>
          </div>
          <div className="div-block-308">
            <Link
                to={"/studio/authoring/programs"}
                className="link-block-22 w-inline-block"
            >
              <div data-w-id="0579eadf-bcf5-cf0e-3353-b66eb69968b8"
                   className="div-block-207 first active follow-user back-to-course-btn">
                <img src="/images/move-left.svg" loading="lazy" alt className="back-to-course-btn-icon"/>
                <div className="text-block-111">Back to all programs</div>
              </div>
            </Link>
          </div>
        </div>
        <div className="w-layout-vflex flex-block-32">
          <div className="w-layout-hflex flex-block-33">
            <div className="div-block-147 new_msg course-creation-form-helper-text">
              <div className="text-block-135 mg-0 smaller" style={{width:"100%"}}>Fill in this form  to create
                a new program
              </div>
              <div className="div-block-264 f-w course-creation-submit-btn-block">
                <div data-w-id="f2ed8e4f-e0fe-f403-ec28-b3ea4450eabf" onClick={submitting ? ()=>{} : handleFormSubmit}
                     className={`div-block-207 first active follow-user redeem-btn mg-l16 program-enroll course-creation-form-btn ${submitting ? "disabled" : ""}`}>
                  <div className="text-block-111 red-text cf" style={{display:"flex", alignItems:"center", gap:"10px"}}><span>Submit</span>{submitting && (
                      <span><IBLSpinLoader size={15} color={"#FFF"}/> </span>)}</div>
                </div>
              </div>
            </div>
            {/*<div className="div-block-264 f-w course-creation-submit-btn-block">
              <div data-w-id="f2ed8e4f-e0fe-f403-ec28-b3ea4450eabf" onClick={submitting ? ()=>{} : ()=>goToNextTab()}
                   className={`div-block-207 first active follow-user redeem-btn mg-l16 program-enroll course-creation-form-btn ${submitting ? "disabled" : ""}`}>
                <div className="text-block-111 red-text cf" style={{display:"flex", alignItems:"center", gap:"10px"}}><span>{isLastTab() ? "Submit" : "Next"}</span>{submitting && (
                    <span><IBLSpinLoader size={15} color={"#FFF"}/> </span>)}</div>
              </div>
            </div>*/}
          </div>
          <div className="div-block-228 course-creation-tabs-content-block" style={{width:'100%'}}>
            <div className="form-block-7 w-form">
              <form onSubmit={e => {
                e.preventDefault()
              }} id="email-form-5" name="email-form-5" data-name="Email Form 5" method="get"
                    data-wf-page-id="678801fa35532f7aa72dff71"
                    data-wf-element-id="de3fb6ec-41c5-4235-b0f0-bb45d2a0d7ef">
                <label htmlFor="name-2"
                       className="text-block-139-bd-f-soc">Program
                  name *</label>
                <input value={fields?.program_name} onChange={e => setFields({
                  ...fields,
                  program_name: e?.target?.value
                })} className="text-field-3 w-input license-name-input" maxLength="256"
                       name="name-2"
                       data-name="Name 2" placeholder="Program name" type="text"
                       id="name-2"/>
                <p className={"form-field-helper"}>100 characters max</p>
                <label htmlFor={"course-selection"}
                     className="text-block-139-bd-f-soc">Courses *</label>
                <Async
                    id={"course-selection"}
                    isMulti
                    cacheOptions
                    classNamePrefix={'react-select'}
                    defaultOptions
                    loadOptions={coursePromiseOptions}
                    value={fields?.courses}
                    options={fields?.courses}
                    onChange={handleCourseChange}
                    isSearchable={true}
                    placeholder={"Search for courses..."}
                />
                <label
                    htmlFor="start_date" className="text-block-139-bd-f-soc">Start date</label>
                <input value={fields?.start_date} min={dayjs().format("YYYY-MM-DDThh:mm")} onChange={e => setFields({
                  ...fields,
                  start_date: e?.target?.value
                })} className="text-field-3 w-input license-name-input" maxLength="256"
                       name="name-2"
                       data-name="Name 2" type="datetime-local"
                       id="start_date" />
                <label htmlFor="description_field"
                       className="text-block-139-bd-f-soc">Program
                  description *</label><textarea placeholder="Description" maxLength={5000} id="description_field"
                                                 name="description" data-name="Field 5"
                                                 value={fields?.description}
                                                 className="textarea-3 w-input ft-size-13"
                                                 onChange={handleInputChange}/><label
                  htmlFor="duration_field" className="text-block-139-bd-f-soc">Program duration *</label><input
                  className="text-field-3 w-input" maxLength={10} name="duration" onChange={handleInputChange}
                  value={fields?.duration} data-name="Name 2"
                  placeholder="Duration" type="text" id="duration_field"/>
                <p className={"form-field-helper"}>e.g 1 hour | 10 characters max</p>
                <div className="w-layout-hflex flex-block-31">
                  <label htmlFor="name-3"
                         className="text-block-139-bd-f-soc">Program
                    card image *</label>
                  {
                      !imageCardUploadLoading && imageCardUploadResponse?.asset?.display_name && (
                          <Link target={"_blank"} to={imageCardUploadResponse?.asset?.external_url}
                                className="link-block-25 w-inline-block"><img src="/images/paperclip-1.svg"
                                                                              loading="lazy" alt
                                                                              className="image-151"/>
                            <div>{imageCardUploadResponse?.asset?.display_name}</div>
                          </Link>
                      )
                  }
                  {
                      imageCardUploadLoading && <IBLSpinLoader size={20} color={"#FFF"}/>
                  }
                  <input
                      ref={imageCardUploadInputElement}
                      onChange={handleImageCardUploadChange}
                      type="file"
                      className="credential-icon-upload-input"
                      accept="image/*"
                  />
                </div>
                <div onClick={() => handleImageCardUploadClick()}
                     className="div-block-207 first active follow-user redeem-btn mg-l16 no-mg-left">
                  <div className="text-block-111 red-text cf">Upload</div>
                </div>
                <div >
                  <label className="text-block-139-bd-f-soc">Credential Eligible <span style={{marginLeft:"15px"}}><label className="user-switcher">
                    <input
                        type="checkbox"
                        checked={fields?.credential}
                        onChange={()=>{
                          setFields({
                            ...fields,
                            credential: !fields?.credential,
                          })
                        }}
                    />
                    <span className="user-switcher-slider round"></span>
                  </label></span></label>
                  <p className={"form-field-helper"}>Whether program has credentials</p>
                </div>
                <label
                    htmlFor="display_price" className="text-block-139-bd-f-soc">Display price</label>
                <input value={fields?.display_price} min={0} onChange={e => setFields({
                  ...fields,
                  display_price: e?.target?.value
                })} className="text-field-3 w-input license-name-input" maxLength="10"
                       name="name-2"
                       data-name="Name 2" type="text"
                       id="display_price" />
              </form>
              <div className="w-form-done">
                <div>Thank you! Your submission has been received!</div>
              </div>
              <div className="w-form-fail">
                <div>Oops! Something went wrong while submitting the form.</div>
              </div>
            </div>
          </div>
        </div>
      </>
  );
};

export default StudioAuthoringProgramCreationViewContent;